const CsatTypeSelector = Vue.component('CsatTypeSelector', {
  data() {
    return {
      options: [
        { value: 'csat', label: '1 a 5' },
        { value: 'csat7', label: '1 a 7' }
      ]
    };
  },
  computed: {
    ...Vuex.mapGetters('epaAnalytics', ['filters']),
    selectedType() {
      return this.filters.csatType || 'csat';
    }
  },
  methods: {
    ...Vuex.mapActions('epaAnalytics', ['setFilters']),
    onChange(event) {
      this.setFilters({ csatType: event.target.value });
    }
  },
  template: `
    <div class="d-flex align-center px-1 pb-2 py-1 bg-white">
      <label class="mr-2">{{ $t('scale') }}:</label>
      <select class="ads-select" :value="selectedType" @change="onChange" style="max-width: 140px">
        <option v-for="option in options" :key="option.value" :value="option.value">
          {{ $t(option.label) }}
        </option>
      </select>
    </div>
  `,
  i18n: {
    messages: {
      es: {
        scale: 'Escala',
        '1 a 5': '1 a 5',
        '1 a 7': '1 a 7'
      },
      pt: {
        scale: 'Escala',
        '1 a 5': '1 a 5',
        '1 a 7': '1 a 7'
      },
      en: {
        scale: 'Scale',
        '1 a 5': '1 to 5',
        '1 a 7': '1 to 7'
      }
    }
  }
}); 